import TextField from "../../../../components/fields/textField/TextField.vue";
import SelectField from "../../../../components/fields/selectField/SelectField.vue";
import PeriodoField from "../../../../components/fields/periodoField/PeriodoField.vue";
import TextAreaField from "../../../../components/fields/textAreaField/TextAreaField.vue";
import FileInputField from "../../../../components/fields/file-input-field/FileInputField.vue";
import { tipoPerfil } from "../../../../constants";
import { SnackBarModule } from "../../../../modules/SnackBarModule";

import {
  EmitirRelatorioService
} from "../../../../services/EmitirRelatorioService.js";

export default {
  name: "PermissaoEmissao",

  components: {
    TextField,
    SelectField,
    PeriodoField,
    TextAreaField,
    FileInputField
  },

  beforeMount() {
    this.initializeForm();
  },

  watch: {
    'form.perfil'(value){

      if(tipoPerfil[value] == 5 || tipoPerfil[value] == 8){
        this.pegarPermissaoPerfil();

      }


    }
  },

  mounted() {},


  data: () => ({
    form: {},
    options: {},
    tipo: "",
    loading: {
      btn: false,
      getPermissions:false
    }

  }),


  methods: {
    initializeForm() {
      this.form = {
        relatorios: [],
        perfil: 'CHEFE_SEPLAN'
      }

    },
    prepareForm() {
      const formData = new FormData();

      if(this.form.perfil == null || this.form.relatorios == []){
        SnackBarModule("Campo obrigatório não informado", "error");
        return;

      }
      this.form.relatorios.forEach( (element, index) => {
        
        formData.append(`relatorios[${index}][id_tipo_relatorio]`,element)
        formData.append(`relatorios[${index}][id_perfil]`,tipoPerfil[this.form.perfil])
      });

      this.saveForm(formData);
      return;
    },

    async pegarPermissaoPerfil(){
      this.loading.getPermissions = true;

      this.form.relatorios = [];
      const response = await EmitirRelatorioService.pegarPermissaoPerfil(tipoPerfil[this.form.perfil]);


      response.data.forEach((value) => {
        this.form.relatorios.push(value.toString())
      })
      this.loading.getPermissions = false;


    },

    async saveForm(formData) {
      this.loading.btn = true;
      const response = await EmitirRelatorioService.definirPermissaoEmissao(formData);
      this.loading.btn = false;
      if (response) {
        this.close();
      }
    },

    close() {
      this.$emit('on-close');
    },
  },
};